var map = {
	"./addtoprofilebutton_de.png": 65,
	"./addtoprofilebutton_en.png": 66,
	"./addtoprofilebutton_fr.png": 67,
	"./award_land_der_ideen.jpg": 68,
	"./cc.png": 69,
	"./certificate_sample.jpg": 70,
	"./clear.png": 71,
	"./companies.jpg": 72,
	"./course-cover-default.jpg": 73,
	"./course-placeholder.jpg": 74,
	"./course_default.png": 75,
	"./download-easy-guide.jpg": 76,
	"./drag_dark.png": 77,
	"./drag_light.png": 78,
	"./draggable.png": 79,
	"./example_voucher_card_de.jpg": 80,
	"./example_voucher_card_en.jpg": 81,
	"./example_voucher_card_fr.jpg": 82,
	"./fabian.jpg": 83,
	"./female_speaker_bg.jpg": 84,
	"./h5p_docu_1.png": 85,
	"./h5p_docu_2.png": 86,
	"./logo-iversity-without-padding.png": 87,
	"./logo-iversity.png": 88,
	"./logo_highres.png": 89,
	"./logo_iversity_springer.svg": 90,
	"./organisation_purchase.jpg": 91,
	"./petal_cutted.png": 92,
	"./posters_points.png": 93,
	"./professor_bg.jpg": 94,
	"./purchase_voucher_header.jpg": 95,
	"./referrals.jpg": 96,
	"./speech-bubble.svg": 97,
	"./voucher_card.png": 98,
	"./work_with_us.png": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;